import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "frame"];

  disconnect() {
    if (this.dialogTarget.open) this.dialogTarget.close();
  }

  open(event) {
    this.opener = event.currentTarget;
    const url = new URL(event.params.url, window.location.origin);
    url.searchParams.set("operatore", this.element.querySelector("#operatore-rapido")?.value || "");
    url.searchParams.set("data", this.element.querySelector("#data-rapida")?.value || "");
    this.frameTarget.removeAttribute("src");
    this.frameTarget.innerHTML = '<p class="text-muted p-3 mb-0" role="status">Caricamento…</p>';
    this.dialogTarget.setAttribute("aria-labelledby", "registrazione-dialog-title");
    this.dialogTarget.showModal();
    this.frameTarget.src = url.toString();
  }

  loaded() {
    const select = this.frameTarget.querySelector("select");
    if (select?.tomselect) this.dialogTarget.querySelector("button")?.focus({ preventScroll: true });
    else this.frameTarget.querySelector("select, input:not([type=hidden]), a")?.focus();
  }

  close() {
    this.dialogTarget.close();
    this.opener?.focus();
  }

  backdrop(event) {
    if (event.target !== this.dialogTarget) return;
    const rect = this.dialogTarget.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
  }

  minutes(event) {
    const input = event.currentTarget.closest("form").querySelector('[name="registrazione[minuti]"]');
    input.value = event.params.value;
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
